import { useDeleteItem } from "http-hooks/item/useItem";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteItem({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteItem();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Item"
      description="Are you sure you want to delete this Item? This Item will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
